var map = {
	"./s0.png": "a949",
	"./s1.png": "b109",
	"./s2.png": "aa24",
	"./s3.png": "28e8",
	"./s4.png": "e072",
	"./s5.png": "1ad4",
	"./s6.png": "fb50",
	"./s7.png": "c931",
	"./swich_close.png": "19ab",
	"./swich_open.png": "8f15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c762";